import React from 'react';

const CharacterAbout = ({ character }) => {
  return (
    <div className="tab-content">
      <div className="left-column">
        <div className="synopsis">
          <h3>Character Details</h3>
          <p>{character.about || 'No description available.'}</p>
        </div>
      </div>

      <div className="right-column">
        <div className="content-tags">
          <div className="tag-group">
            <h4>Personal Info</h4>
            <div className="personal-info-grid">
              <PersonalInfoItem label="Age" value={character.age} />
              <PersonalInfoItem 
                label="Height" 
                value={character.height ? `${character.height} cm` : 'N/A'} 
              />
              <PersonalInfoItem label="Birthday" value={character.birthday} />
              <PersonalInfoItem 
                label="Occupation" 
                value={character.occupation?.join(', ')} 
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const PersonalInfoItem = ({ label, value }) => (
  <div className="detail-item">
    <span className="label">{label}</span>
    <span className="value">{value || 'N/A'}</span>
  </div>
);

export default CharacterAbout;